import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export const getManagePersonalizationManageHomeUrl = () => `${getFullUrl('app')}/personalization/${PortalIdParser.get()}/home/manage`;
export const getManagePersonalizationVariantsUrl = strategyId => {
  if (!strategyId) {
    return getManagePersonalizationManageHomeUrl();
  }
  return `${getFullUrl('app')}/personalization/${PortalIdParser.get()}/variants/${strategyId}`;
};